import React from "react";

const JQuery_Load = () => {
  return (
    <div>
      <h1>JQuery_Load</h1>
      <p>Placeholder component for: "JQuery_Load"</p>
    </div>
  );
};

export default JQuery_Load;
